module.exports = __webpack_public_path__ + "img/error.d4f5a7d5.png";